import { useMediaQuery } from '@mui/material'
import { IconId } from 'components'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { UserType } from 'types'
import { DesktopMainSidebar, MobileMainSidebar } from 'views'
import { theme } from '../../config'
import { Pages, RoutingParams } from '../../routes'
import { AuthStore, RoutingStore } from '../../stores'


export interface IMainSidebarProps {
  routingStore?: RoutingStore,
  authStore?:    AuthStore,
}

export type SidebarMenuItem = {
  listItemText :  string,              // Display name in the sidebar
  nestedItems?:   SidebarMenuItem[],   // Subitems shown when item is expanded
  path?:          Pages,               // Routing path that is routed to when clicked, undefined when @nestedItems is defined
  routingParams?: RoutingParams,
  userTypes?:     UserType[],          // If defined, will only show this to users of specified types
  icon?:          IconId,
  showNested?:    boolean,             // Programmatically open the nested items accordon
  selected?:      boolean,             // Alternative condition to indicate that the item is seleceted. By default the path will be matched with the current location. 
}


export type FooterListItem = {
  listItemText:  string,
  icon:          IconId,
  url:           string,
  tooltip:       string,
  color:         string,
  textColor:     string,
}

export const MainSidebar = inject('routingStore', 'authStore')(observer((props: IMainSidebarProps): JSX.Element => {
  const isDesktopView = useMediaQuery(theme.breakpoints.up('sm'));

  if(isDesktopView) return <DesktopMainSidebar />;
  return <MobileMainSidebar />;
}));
